"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processCourseDescription = exports.generateUniqueString = exports.lowerFirstLetter = exports.capitalizeFirstLetter = exports.equalIgnoreCase = exports.compareString = void 0;
/* eslint-disable no-useless-escape */
var compareString = function (a, b, ignoreCase) {
    if (ignoreCase === void 0) { ignoreCase = false; }
    if (ignoreCase) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
    }
    else {
        return a.localeCompare(b);
    }
};
exports.compareString = compareString;
var equalIgnoreCase = function (a, b) {
    return (0, exports.compareString)(a, b, true) === 0;
};
exports.equalIgnoreCase = equalIgnoreCase;
var capitalizeFirstLetter = function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
exports.capitalizeFirstLetter = capitalizeFirstLetter;
var lowerFirstLetter = function (str) {
    return str.charAt(0).toLowerCase() + str.slice(1);
};
exports.lowerFirstLetter = lowerFirstLetter;
var generateUniqueString = function (str) {
    if (str === void 0) { str = ''; }
    return str.replace(/\s/g, '') + '_' + Math.random().toString(36).substr(2, 9);
};
exports.generateUniqueString = generateUniqueString;
var processCourseDescription = function (str) {
    // https://stackoverflow.com/questions/32225635/regex-to-remove-all-br-tags-from-beginning-and-end-of-a-string-in-javascript?rq=1
    // removing <br> at the beginning and in the end
    var modifiedDescription = str.replace(/<br\s*\/?>/gm, '');
    // https://stackoverflow.com/questions/20569140/remove-extra-brs-from-a-string
    // replacing <br><br>...<br> into only one <br>
    modifiedDescription = modifiedDescription.replace(/<\/?br\s*\/?>\s*(<\/?br\s*\/?>)+/gi, '<br/>');
    return modifiedDescription;
};
exports.processCourseDescription = processCourseDescription;
